// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wm-track-related-poi {
  --height: 75px;
  display: flex;
  flex-direction: column;
  margin: var(--wm-feature-details-margin);
}
wm-track-related-poi > ion-label {
  font-weight: var(--wm-feature-details-title-font-weight);
  font-size: var(--wm-feature-details-title-font-size);
  color: var(--wm-feature-details-title-color);
  font-family: var(--wm-feature-details-title-font-family);
}
wm-track-related-poi .webmapp-track-poi-btns {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: stretch;
}
wm-track-related-poi .webmapp-track-poi-btns .webmapp-poi-popup-btn {
  order: 0;
  flex: 0 1 auto;
  align-self: auto;
  font-family: var(--wm-font-family-content);
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: baseline;
}
wm-track-related-poi .webmapp-track-poi-btns .webmapp-poi-popup-btn i {
  flex: 0 1 20px;
  align-self: auto;
  font-size: 18px;
}
wm-track-related-poi .webmapp-track-poi-btns .webmapp-poi-popup-btn .wm-icn {
  color: var(--wm-color-primary);
  margin-right: 5px;
  flex: 0 1 auto;
}
wm-track-related-poi .webmapp-track-poi-list {
  padding: 10px 0px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: stretch;
}
wm-track-related-poi .webmapp-track-poi-list .webmapp-track-poi-item {
  flex: 0 1 auto;
  align-self: auto;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: stretch;
  height: var(--height);
  cursor: pointer;
}
wm-track-related-poi .webmapp-track-poi-list .webmapp-track-poi-text {
  width: calc(100% - 100px);
  height: 100%;
  margin-left: 16px;
  flex: 1 1 auto;
  align-self: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
wm-track-related-poi .webmapp-track-poi-list .webmapp-track-poi-text .webmapp-track-poi-title {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0em;
  text-align: left;
  color: var(--ion-text-color);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
wm-track-related-poi .webmapp-track-poi-list .webmapp-track-poi-text .webmapp-track-poi-distance-from-current-location {
  font-size: 12px;
  color: var(--ion-text-color);
}
wm-track-related-poi .webmapp-track-poi-list .webmapp-track-poi-text .webmapp-track-poi-distance-from-current-location span {
  font-weight: 700;
}
wm-track-related-poi .webmapp-track-poi-list .webmapp-track-poi-text .webmapp-track-poi-btns {
  display: inline-flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: flex-start;
}
wm-track-related-poi .webmapp-track-poi-list .webmapp-track-poi-img {
  width: 100px;
  left: 0px;
  top: 0px;
  border-radius: 8px;
  object-fit: cover;
  flex: 0 1 auto;
  align-self: auto;
}
wm-track-related-poi .webmapp-track-poi-list wm-icon {
  height: 100%;
  display: flex;
}
wm-track-related-poi .webmapp-track-poi-list wm-icon svg {
  height: 100%;
  padding: 4px;
}
wm-track-related-poi .webmapp-track-poi-list .selected {
  background-color: rgb(243, 244, 246);
  border-radius: 8px;
}
wm-track-related-poi > ion-button {
  height: 36px;
  font-size: var(--wm-font-sm);
  margin-top: 16px;
  --box-shadow: none;
  --border-radius: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/wm-core/projects/wm-core/src/track-related-poi/track-related-poi.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EAEA,aAAA;EACA,sBAAA;EACA,wCAAA;AAAF;AACE;EACE,wDAAA;EACA,oDAAA;EACA,4CAAA;EACA,wDAAA;AACJ;AACE;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,2BAAA;EACA,sBAAA;EACA,oBAAA;AACJ;AAAI;EACE,QAAA;EACA,cAAA;EACA,gBAAA;EACA,0CAAA;EAEA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,sBAAA;EACA,qBAAA;AACN;AAAM;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAER;AAAM;EACE,8BAAA;EACA,iBAAA;EACA,cAAA;AAER;AAEE;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,2BAAA;EACA,sBAAA;EACA,oBAAA;AAAJ;AACI;EACE,cAAA;EACA,gBAAA;EAEA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,eAAA;AAAN;AAEI;EACE,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAAN;AACM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,4BAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AACR;AAEM;EACE,eAAA;EACA,4BAAA;AAAR;AACQ;EACE,gBAAA;AACV;AAEM;EAGE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,sBAAA;EACA,uBAAA;AAAR;AAII;EACE,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAFN;AAII;EACE,YAAA;EACA,aAAA;AAFN;AAGM;EACE,YAAA;EACA,YAAA;AADR;AAII;EACE,oCAAA;EACA,kBAAA;AAFN;AAKE;EACE,YAAA;EACA,4BAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AAHJ","sourcesContent":["wm-track-related-poi {\n  --height: 75px;\n\n  display: flex;\n  flex-direction: column;\n  margin: var(--wm-feature-details-margin);\n  > ion-label {\n    font-weight: var(--wm-feature-details-title-font-weight);\n    font-size: var(--wm-feature-details-title-font-size);\n    color: var(--wm-feature-details-title-color);\n    font-family: var(--wm-feature-details-title-font-family);\n  }\n  .webmapp-track-poi-btns {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n    align-content: stretch;\n    align-items: stretch;\n    .webmapp-poi-popup-btn {\n      order: 0;\n      flex: 0 1 auto;\n      align-self: auto;\n      font-family: var(--wm-font-family-content);\n\n      display: inline-flex;\n      flex-direction: row;\n      flex-wrap: nowrap;\n      justify-content: flex-start;\n      align-content: stretch;\n      align-items: baseline;\n      i {\n        flex: 0 1 20px;\n        align-self: auto;\n        font-size: 18px;\n      }\n      .wm-icn {\n        color: var(--wm-color-primary);\n        margin-right: 5px;\n        flex: 0 1 auto;\n      }\n    }\n  }\n  .webmapp-track-poi-list {\n    padding: 10px 0px;\n    display: flex;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n    align-content: stretch;\n    align-items: stretch;\n    .webmapp-track-poi-item {\n      flex: 0 1 auto;\n      align-self: auto;\n\n      display: flex;\n      flex-direction: row;\n      flex-wrap: nowrap;\n      justify-content: flex-start;\n      align-content: stretch;\n      align-items: stretch;\n      height: var(--height);\n      cursor: pointer;\n    }\n    .webmapp-track-poi-text {\n      width: calc(100% - 100px);\n      height: 100%;\n      margin-left: 16px;\n      flex: 1 1 auto;\n      align-self: auto;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      .webmapp-track-poi-title {\n        font-size: 16px;\n        font-weight: 700;\n        line-height: 1.2;\n        letter-spacing: 0em;\n        text-align: left;\n        color: var(--ion-text-color);\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n      }\n\n      .webmapp-track-poi-distance-from-current-location {\n        font-size: 12px;\n        color: var(--ion-text-color);\n        span {\n          font-weight: 700;\n        }\n      }\n      .webmapp-track-poi-btns {\n        display: -ms-inline-flexbox;\n        display: -webkit-inline-flex;\n        display: inline-flex;\n        flex-direction: row;\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n        align-content: stretch;\n        align-items: flex-start;\n      }\n    }\n\n    .webmapp-track-poi-img {\n      width: 100px;\n      left: 0px;\n      top: 0px;\n      border-radius: 8px;\n      object-fit: cover;\n      flex: 0 1 auto;\n      align-self: auto;\n    }\n    wm-icon {\n      height: 100%;\n      display: flex;\n      svg {\n        height: 100%;\n        padding: 4px;\n      }\n    }\n    .selected {\n      background-color: rgba(243, 244, 246, 1);\n      border-radius: 8px;\n    }\n  }\n  > ion-button {\n    height: 36px;\n    font-size: var(--wm-font-sm);\n    margin-top: 16px;\n    --box-shadow: none;\n    --border-radius: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
